import type { BanDich } from '../types';
import type { viManTokenAi } from './token-ai.vi';

/** Strings for the tenant AI tokens screen (ADR-0123). */
export const enManTokenAi: Pick<BanDich, keyof typeof viManTokenAi> = {
  manTokenAi: {
    vuot: '{{so}} tokens over',
    theSuDung: 'Usage',
    theHanMuc: 'Limits',
    theNapToken: 'Top up',
    dauVao: 'Input',
    dauRa: 'Output',
    tong: 'Total',
    rong: 'No AI usage in this period',
    theoNgay: 'Fox tokens per day',
    theoNgayNhan: 'Fox input and output tokens per day over the last {{so}} days',
    chonKhoang: 'Choose a date range',
    soNgay: '{{so}} days',
    phanTich: 'By month',
    chonThang: 'Choose a month',
    theoTinhNang: 'By feature',
    theoPhongBan: 'By department',
    theoNguoiDung: 'Top users',
    theoModel: 'By model',
    khongGanTinhNang: 'Other features',
    khongGanDonVi: 'No department',
    khongGanNguoi: 'Automated, no user',
    khac: 'Other ({{so}} items)',
    soLuot: 'Calls',
    moTaDong: '{{ten}}: input {{vao}}, output {{ra}}, total {{tong}} Fox tokens, {{luot}} calls',
    dongSo: 'In {{vao}} · Out {{ra}} · {{luot}} calls',
    phamViDonVi: 'Department',
    phamViNguoi: 'User',
    hanhDongChan: 'Block',
    hanhDongCanhBao: 'Warn only',
    chuKyNgay: 'Day',
    chuKyTuan: 'Week',
    chuKyThang: 'Month',
    moiTinhNang: 'All features',
    moiPhamVi: 'All scopes',
    locPhamVi: 'Filter by scope',
    giaiThich:
      'A limit is a cap inside your plan, not an allocation: limits may add up to more than the plan, and the plan stays the overall cap. A department limit also covers its sub-departments.',
    themHanMuc: 'Add limit',
    suaHanMuc: 'Edit limit',
    xoaHanMuc: 'Delete limit',
    luuThayDoi: 'Save changes',
    dangLuu: 'Saving...',
    cotPhamVi: 'Scope',
    cotDoiTuong: 'Applies to',
    cotTinhNang: 'Feature',
    cotChuKy: 'Period',
    cotDaDung: 'Used / limit',
    cotHanhDong: 'Action',
    cotBat: 'On',
    bangCaption: 'Fox token limits by department and user',
    daDungTren: '{{daDung}} / {{gioiHan}}',
    moLai: 'Resets on {{ngay}}',
    doiTuongKhongCon: 'No longer in the organization',
    batNhan: 'Turn on the limit for {{ten}}',
    rongHanMuc: 'No limits yet',
    rongHanMucMo: 'Set a Fox token cap for a department or a person so the plan isn’t used up early.',
    rongLoc: 'No limits match this filter',
    chonPhongBan: 'Choose a department',
    soToken: 'Fox tokens',
    goiYChan: 'Once the limit is reached, AI calls in this scope stop until it resets.',
    goiYCanhBao: 'Usage continues; admins are notified at 80% and 100%.',
    loiChonPhongBan: 'Choose a department.',
    loiChonNguoi: 'Choose a user.',
    loiSoTrong: 'Enter the number of Fox tokens.',
    loiSoSai: 'Enter a whole number, such as 20,000.',
    loiSoQuaLon: 'That number is too large. The maximum is 1,000,000,000,000.',
    loiSoKhong: 'Enter a number greater than 0.',
    daTao: 'Limit added.',
    daLuu: 'Changes saved.',
    daXoa: 'Limit deleted.',
    daBat: 'Limit turned on.',
    daTat: 'Limit turned off.',
    xoaTieuDe: 'Delete the limit for {{ten}}?',
    xoaThan: 'This limit will no longer apply to them; the organization’s plan still does. This can’t be undone.',
    dashboardCanhBao: 'Your organization has used {{so}}% of this month’s AI token quota.',
    dashboardVuot: 'Your organization is over this month’s AI token quota.',
    canhBaoVuot:
      'Your organization is over this month’s AI token quota. Once the remainder runs out, AI features pause until {{ngay}}; send a request on the Top up tab if you need more.',
    dashboardXem: 'View AI tokens',
  },
};
